// extracted by mini-css-extract-plugin
export default {"container":"LD-z","dimension":"MD-z","dimensionLabels":"ND-z"};